// 记录正则表达式

// 匹配 https 或 http 链接
export const HTTP_URL_REGEXP = /^https?:\/\//i;

// 匹配邮箱 与 server 端校验规则保持一致
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
